:host {
  display: block;
  margin-bottom: 50px;
  margin-top: 50px;

  td:last-child {
    text-align: end;

    .ui-button {
      //to prevent scroll - opposite of cell padding, see .ui-table tbody tr td
      margin: -14px -8px;
    }
  }

  .ui-table table {
    margin-bottom: 36px;
    // TODO: remove once UMAGDXC-2501 has been merged
    width: 100%;

    th,
    td {
      border-right-color: transparent;
      // TODO: remove once UMAGDXC-2501 has been merged
      white-space: normal;
    }
  }

  table {
    margin-bottom: 36px;
  }

  .remove-all {
    text-align: right;
  }
}
